<template>
  <div class="document_box">
    <Tabbar :title="$t('documentDetails.title')" background="#3fbb70"></Tabbar>
    <div class="head_box">
      <div class="document_title">
        {{ title }}
      </div>
      <div class="document_content" v-html="content"></div>
    </div>
    <!-- 签名文件 -->
    <div class="sign_box" v-show="signBoxShow">
      <div class="sign_title">{{ $t('documentDetails.contract') }}</div>
      <div class="sign_item" v-for="(item, index) in signList" :key="index">
        <div class="flex">
          <img class="file_icon" :src="item.icon" alt="" />
          {{ item.name }}
        </div>
        <div v-if="item.status == 0" @click="toSign(item)" class="sign_btn">
          {{ $t('documentDetails.goToSign') }}
        </div>
        <div v-else class="download" @click="downloadImage(item.url, item.name)">
          {{ $t('documentDetails.download') }}
        </div>
      </div>
    </div>
    <!-- 根据uploadRules上传文件规则对应显示 -->
    <div class="item_box" v-for="item in uploadRules" :key="item.name">
      <div v-if="item.type !== '1,2'" class="item_name">{{ item.name }}</div>
      <!-- 上传文件 -->
      <div v-if="item.type === '1'" class="relative">
        <!-- 上传身份信息 -->
        <div v-show="item.name === 'ID card'">
          <div class="file_name">{{ uploadRulesData.idCardUrl }}</div>
          <input
            :class="$store.state.isMirroring && 'mirror'"
            class="content_item_input_upload"
            type="file"
            @change="uploadFile('IdCard')"
            ref="IDCardInput"
            accept=".doc,.pdf,image/*,.xlsx,.xls"
          />
        </div>
        <!-- 自定义文件上传 -->
        <div v-show="item.key && item.key === 'customName'">
          <div class="file_name">{{ uploadRulesData.customUrl }}</div>
          <input
            :class="$store.state.isMirroring && 'mirror'"
            class="content_item_input_upload"
            type="file"
            @change="uploadFile('CustomUrl')"
            ref="customUrlInput"
            accept=".doc,.pdf,image/*,.xlsx,.xls"
          />
        </div>
        <div class="sign_btn upload_btn">
          {{ $t('documentDetails.upload') }}
        </div>
        <div class="file_tips">
          {{ $t('documentDetails.fileTypeLimit') }}
        </div>
      </div>
      <!-- 文本域 -->
      <div v-if="item.type === '2'" class="textarea_box">
        <!-- 出生地 -->
        <van-field
          v-show="item.name === 'Place of Birth'"
          v-model="uploadRulesData.placeOfBirth"
          rows="5"
          autosize
          type="textarea"
          maxlength="200"
          :placeholder="$t('documentDetails.contentEmptyToast')"
          show-word-limit
        />
        <!-- 职业 -->
        <van-field
          v-show="item.name === 'Occupation'"
          v-model="uploadRulesData.occupation"
          rows="5"
          autosize
          type="textarea"
          maxlength="200"
          :placeholder="$t('documentDetails.contentEmptyToast')"
          show-word-limit
        />
      </div>
      <!-- 文件和文本都需要 -->
      <div v-if="item.type === '1,2'">
        <div class="item_name">{{ item.name + $t('documentDetails.fileForm') }}</div>
        <div class="relative">
          <!-- 上传地址 -->
          <div v-show="item.name === 'Bank Statements'">
            <div class="file_name">{{ uploadRulesData.addressUrl }}</div>
            <input
              :class="$store.state.isMirroring && 'mirror'"
              class="content_item_input_upload"
              type="file"
              @change="uploadFile('Address')"
              ref="addressInput"
              accept=".doc,.pdf,image/*,.xlsx,.xls"
            />
          </div>
          <!-- 上传居住证明 -->
          <div v-show="item.name === 'Residence Document'">
            <div class="file_name">{{ uploadRulesData.residenceUrl }}</div>
            <input
              :class="$store.state.isMirroring && 'mirror'"
              class="content_item_input_upload"
              type="file"
              @change="uploadFile('Residence')"
              ref="residenceInput"
              accept=".doc,.pdf,image/*,.xlsx,.xls"
            />
          </div>
          <div class="sign_btn upload_btn">
            {{ $t('documentDetails.upload') }}
          </div>
          <div class="file_tips">
            {{ $t('documentDetails.fileTypeLimit') }}
          </div>
        </div>
        <div class="item_name">{{ item.name + $t('documentDetails.textForm') }}</div>
        <div class="textarea_box">
          <!-- 地址 -->
          <van-field
            v-show="item.name === 'Bank Statements'"
            v-model="uploadRulesData.addressText"
            rows="5"
            autosize
            type="textarea"
            maxlength="200"
            :placeholder="$t('documentDetails.contentEmptyToast')"
            show-word-limit
          />
          <!-- 居住证明 -->
          <van-field
            v-show="item.name === 'Residence Document'"
            v-model="uploadRulesData.residenceText"
            rows="5"
            autosize
            type="textarea"
            maxlength="200"
            :placeholder="$t('documentDetails.contentEmptyToast')"
            show-word-limit
          />
        </div>
      </div>

      <!-- 日期筛选 -->
      <div v-if="item.type === '3'">
        <div @click="datePickerShow = !datePickerShow">
          {{ formatDate(currentDate, 'YYYY-MM-DD') }}
        </div>
        <van-datetime-picker
          v-show="datePickerShow"
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="confirmBirth"
          @cancel="datePickerShow = false"
        />
      </div>
    </div>
    <div class="submit_box flex">
      <div v-if="submitShow" class="submit_btn" @click="submit">
        {{ submitBtn }}
      </div>
      <div v-else class="submit_btn noclick_submit_btn">
        {{ submitBtn }}
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import { Toast } from 'vant'
import { formatDate } from '../utils'
import { uploadToAliyunOss } from '../service'

export default {
  name: 'DocumentDetails',
  components: {
    Tabbar
  },
  data() {
    return {
      title: '',
      content: '',
      fileList: [],
      signList: [],
      fileArr: [],
      Uploading: false,
      fileBoxShow: true,
      signBoxShow: true,
      isContract: 0, // 是否需要签署合同
      isWages: 0, // 是否需要工资单
      submitBtn: 'Submit',
      submitShow: false,
      uploadRules: [], // type 1是文件 2是文本
      textModel: '',
      count: 0,
      datePickerShow: false, // 日期选择器
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      currentDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      uploadRulesData: {
        birthday: this.formatDate(new Date(new Date().setFullYear(new Date().getFullYear() - 18)), 'YYYY-MM-DD'),
        idCardUrl: '',
        addressText: '',
        addressUrl: '',
        residenceText: '',
        residenceUrl: '',
        customUrl: '',
        occupation: '',
        placeOfBirth: ''
      },
    }
  },
  mounted() {
    this.getDetail()
  },
  watch: {
    uploadRulesData: {
      handler(newValue, oldValue) {
        if (newValue) {
          const ruleValidation = {
            'Place of Birth': () => this.uploadRulesData.placeOfBirth,
            'ID card': () => this.uploadRulesData.idCardUrl,
            'Bank Statements': () => this.uploadRulesData.addressText && this.uploadRulesData.addressUrl,
            Occupation: () => this.uploadRulesData.occupation,
            'Residence Document': () => this.uploadRulesData.residenceText && this.uploadRulesData.residenceUrl,
            Birthday: () => this.uploadRulesData.birthday,
            customName: () => this.uploadRulesData.customUrl
          }
          // 有其他索取文件
          if (this.uploadRules.length > 0) {
            // 索取文件是否都填写
            let uploadRuleFlag = this.uploadRules.every((item, _index) => {
              const validate = ruleValidation[item.key || item.name]
              return validate && validate()
            })
            // 未索取合同|| 合同已填写
            let contractFlag = (this.isContract && sessionStorage.getItem('contractImg')) || !this.isContract
            // 未索取工资单 || 工资单已填写
            let wagesFlag = (this.isWages && sessionStorage.getItem('wagesImg')) || !this.isWages
            this.submitShow = uploadRuleFlag && contractFlag && wagesFlag
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    uploadOssFile: uploadToAliyunOss().uploadFile,
    formatDate,
    // 修改生日
    confirmBirth() {
      this.datePickerShow = false
      this.uploadRulesData.birthday = this.formatDate(this.currentDate, 'YYYY-MM-DD')
    },
    // 获取索取详情
    getDetail() {
      this.$http
        .get(window.serverPath + '/api/user/kyc/getDetail?userId=' + this.$store.state.userInfo.userId)
        .then((res) => {
          if (res.data.code === '200') {
            let data = res.data.data
            this.uploadRules = data.uploadRules ? JSON.parse(data.uploadRules) : []
            sessionStorage.setItem('agentContractDate', data.agentContractDate)
            sessionStorage.setItem('wagesDetail', data.wagesDetail)
            this.title = data.title
            this.content = data.content
            this.isContract = data.isContract
            this.isWages = data.isWages
            // 只索取合同||工资单
            if (this.uploadRules.length === 0) {
              let contractFlag = (this.isContract && sessionStorage.getItem('contractImg')) || !this.isContract
              let wagesFlag = (this.isWages && sessionStorage.getItem('wagesImg')) || !this.isWages
              this.submitShow = contractFlag && wagesFlag
            }
            if (sessionStorage.getItem('fileList')) {
              this.fileList = JSON.parse(sessionStorage.getItem('fileList'))
            } else {
              this.fileList = [...Array.from({ length: data.userUploadNum })].map(() => {
                return {
                  name: 'Upload the document',
                  icon: require('../assets/upload.png'),
                  status: 0
                }
              })
            }
            if (this.fileList.length === 0) {
              this.fileBoxShow = false
            }
            this.signList = [...Array.from({ length: this.isContract + this.isWages })].map((item, index) => {
              return {
                id: index + 1,
                icon: require('../assets/file.png'),
                status: 0,
                isContract: this.isContract,
                isWages: this.isWages
              }
            })
            if (this.signList.length === 0) {
              this.signBoxShow = false
            } else {
              if (this.isContract && this.isWages) {
                this.signList[0].name = this.$t('documentDetails.contractAgent')
                this.signList[1].name = this.$t('documentDetails.contractPayslip')
              } else if (this.isContract) {
                this.signList[0].name = this.$t('documentDetails.contractAgent')
              } else {
                this.signList[0].name = this.$t('documentDetails.contractPayslip')
              }
              if (sessionStorage.getItem('contractImg') && sessionStorage.getItem('wagesImg')) {
                this.signList[0].url = sessionStorage.getItem('contractImg')
                this.signList[1].url = sessionStorage.getItem('wagesImg')
              } else if (sessionStorage.getItem('wagesImg') && this.isWages && this.isContract) {
                this.signList[1].url = sessionStorage.getItem('wagesImg')
              } else {
                this.signList[0].url = sessionStorage.getItem('contractImg') || sessionStorage.getItem('wagesImg')
              }
              this.signList.forEach((item) => {
                if (item.url) {
                  item.icon = require('../assets/file_success.png')
                  item.status = 1
                }
              })
            }
          }
        })
        .catch((err) => console.log(err))
    },
    // 下载图片地址和图片名
    downloadImage(imgsrc, name) {
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    // 文件上传
    uploadFile(type) {
      let inputDOM
      let dataName
      switch (type) {
        case 'IdCard':
          inputDOM = this.$refs.IDCardInput
          dataName = 'idCardUrl'
          break
        case 'CustomUrl':
          inputDOM = this.$refs.customUrlInput
          dataName = 'customUrl'
          break
        case 'Address':
          inputDOM = this.$refs.addressInput
          dataName = 'addressUrl'
          break
        case 'Residence':
          inputDOM = this.$refs.residenceInput
          dataName = 'residenceUrl'
          break
        default:
          Toast({ message: this.$t('documentDetails.undefinedFileTypeToast') })
          return
      }
      let file = inputDOM[0].files.length > 0 ? inputDOM[0].files[0] : inputDOM[1].files[0]
      this.uploadOssFile(file, (res) => {
        this.uploadRulesData[dataName] = res.url
      }, (err) => {
        Toast({ message: this.$t('documentDetails.uploadFailToast') })
        console.error(err)
      })
    },
    // 去签名
    toSign(item) {
      if (item.isContract && item.id === 1) {
        this.$router.push({
          name: 'Signing'
        })
      } else {
        this.$router.push({
          name: 'SigningPayroll'
        })
      }
    },
    // 提交
    submit() {
      if (
        (this.isContract && !sessionStorage.getItem('contractImg')) ||
        (this.isWages && !sessionStorage.getItem('wagesImg')) ||
        !this.fileList.every((item) => item.url)
      ) {
        Toast({
          message: this.$t('documentDetails.uncompletedToast')
        })
        return
      }
      this.submitBtn = 'Submitting'
      if (this.fileList.length > 0) {
        this.fileArr = this.fileList.map((item) => item.url)
      }
      let params = {
        userId: this.$store.state.userInfo.userId,
        userContractUrl: sessionStorage.getItem('contractImg'),
        userWagesUrl: sessionStorage.getItem('wagesImg'),
        otherUrl: this.fileArr
      }
      this.$http
        .post(window.serverPath + '/api/user/kyc/upload', {
          ...params,
          ...this.uploadRulesData
        })
        .then((res) => {
          if (res.data.code === '200') {
            sessionStorage.removeItem('contractImg')
            sessionStorage.removeItem('signImg')
            sessionStorage.removeItem('wagesImg')
            sessionStorage.removeItem('payrollImg')
            sessionStorage.removeItem('fileList')
            sessionStorage.removeItem('userInputData')
            sessionStorage.removeItem('wagesDetail')
            sessionStorage.removeItem('agentContractDate')
            Toast.success({
              message: this.$t('documentDetails.successToast'),
              onClose: this.$router.back()
            })
          } else {
            Toast({
              message: this.$t('basicLevel.failToast')
            })
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.tab {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.document_box {
  height: 100vh;
  font-size: 0.14rem;
  background: #f5f5f5;
  padding-bottom: 1rem;
  overflow-y: auto;
  scrollbar-width: 0;
}

.document_box::-webkit-scrollbar {
  width: 0;
}

.head_box {
  width: 100%;
  text-align: left;
  background: #3fbb70;
  padding: 0.1rem 0.18rem 0;
  box-sizing: border-box;
  color: #fff;
}

.document_title {
  font-size: 0.16rem;
  font-weight: 500;
}

.document_content {
  padding: 0.06rem 0 0.4rem;
  line-height: 0.2rem;
}

.sign_box {
  width: 3.39rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #eef1f7;
  margin: -0.3rem auto 0;
  padding: 0 0.12rem;
  font-size: 0.16rem;
  text-align: left;
}

.sign_btn {
  color: #fff;
  text-align: center;
  font-size: 0.14rem;
  width: 1.07rem;
  height: 0.32rem;
  line-height: 0.32rem;
  background: #3fbb70;
  border-radius: 0.17rem;
  font-weight: 500;
}

.sign_title {
  height: 0.4rem;
  display: flex;
  justify-content: start;
  align-items: flex-end;
  font-weight: 500;
  color: #282828;
}

.sign_item {
  height: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file_icon {
  width: 0.36rem;
  height: 0.36rem;
  margin-inline-end: 0.06rem;
}

.download {
  width: 0.9rem;
  height: 0.32rem;
  line-height: 0.32rem;
  border-radius: 0.17rem;
  border: 1px solid #3fbb70;
  text-align: center;
  font-weight: 500;
  color: #3fbb70;
  font-size: 0.14rem;
}

.upload_box {
  margin-top: 0.3rem;
}

.upload_item {
  color: #3fbb70;
}

.file_name {
  max-width: 1.88rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.delete {
  width: 0.67rem;
}

.flex {
  display: flex;
  align-items: center;
}

.submit_box {
  width: 100%;
  height: 0.86rem;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  justify-content: center;
  z-index: 1;
}

.submit_btn {
  width: 3.38rem;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #3fbb70;
  border-radius: 0.37rem;
  font-weight: 600;
  color: #ffffff;
  font-size: 0.16rem;
}

.noclick_submit_btn {
  background: gray;
}

.upload_btn_box {
  position: relative;
}

.content_item_input_upload {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 0.32rem;
  width: 0.71rem;
}

.content_item_input_upload.mirror {
  left: auto;
  right: 0;
}

.upload_btn {
  width: 0.71rem;
}

.uploading_btn {
  width: 0.92rem;
}

.van-button--primary {
  text-align: center;
  font-size: 0.14rem;
  width: 0.71rem;
  height: 0.32rem;
  line-height: 0.32rem;
  background: #3fbb70;
  border-radius: 0.17rem;
  font-weight: 500;
  border: none;
}

.van-button__icon {
  display: none;
}

.file_tips {
  font-size: 0.16rem;
  padding-bottom: 0.3rem;
  line-height: 0.13rem;
  zoom: 0.6;
  text-align: center;
}

.item_box {
  text-align: left;
  padding: 0.1rem;
  box-sizing: border-box;
  background: #fff;
  width: 90%;
  margin: 0.1rem auto;
  border-radius: 0.12rem;
}

.item_name {
  margin-bottom: 0.1rem;
  font-weight: bold;
  word-wrap: break-word;
}

.relative {
  position: relative;
}

.textarea_box {
  position: relative;
  width: 100%;
}

.item_box .file_tips {
  zoom: 0.8;
  padding: 0.1rem 0;
  line-height: 0.2rem;
  text-align: left;
}

.van-cell {
  width: 100%;
  resize: none;
  border-radius: 0.12rem;
  padding: 0.1rem;
  box-sizing: border-box;
  border: 1px solid #2c3e50;
}

.van-datetime-picker {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/DocumentDetails.vue